import {
  SCROLL_BAR,
  borderRadius,
  fontSize,
  fontWeight,
} from '../../utils/constants/UI/uiConstants'
import { makeStyles } from '@mui/styles'
import { innerBorder, innerLeftBorder } from '../../utils/helpers'
import {
  ACTIONS,
  BASE,
  BORDER,
  BRAND,
  GREY,
  HELP,
  SUCCESS,
  WARNING,
} from '../../utils/constants/colors'
import { SHADOW } from '../../utils/constants/UI'
import { TABLE_SCROLL_BAR } from '../../utils/constants/styles'

export const styles = makeStyles({
  tabeHead: {
    height: '100vh',
  },
  tableUi: {
    borderRadius: '6px',
    // borderTopLeftRadius: "6px",
    // borderTopRightRadius: "6px",
    gap: '16px',
    margin: '16px 16px',
    background: BASE.WHITE,
    boxShadow: SHADOW.xs,
    height: 'calc(100% - 100px)',
    ...SCROLL_BAR,
  },
  folderRightSide: {
    display: 'flex',
    // marginTop: "15px",
    marginLeft: '1rem',
    marginRight: '1rem',
    justifyContent: 'space-between',
    '@media (max-width:1700px)': {
      // marginTop: "10px",
    },
  },
  displayFlex: {
    display: 'flex',
    marginTop: '16px',
    marginBottom: '16px',
    justifyContent: 'space-between',
    // marginRight: "25px",
    gap: '8px',
    width: '100%',
  },
  HeadSub: {
    display: 'flex',
    gap: '8px',
  },
  GAP: {
    display: 'flex',
    gap: '8px',
    width: '21.615vw',
  },
  filterered: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    // padding: "0px 16px 16px 16px",
    maxHeight: '200px',
    overflow: 'auto',
    ...SCROLL_BAR,
    '&:hover': {
      // backgroundColor: BASE.BACKGROUND_LIGHT,
      // boxShadow: innerLeftBorder(BRAND.PRIMARY),
    },
  },
  skeletonPadding: {
    padding: '8px 12px',
  },
  innerTable: {
    height: '82vh',
  },
  paeprContainer: {
    height: '100%',
    width: '62.500vw',
    margin: '0px',
    maxHeight: '100vh',
    maxWidth: '100vw',
    marginLeft: 'auto',
    borderRadius: 'none',
    marginRight: '0px ',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 20px',
    height: '68px',
    background: HELP.W_900,
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3px',
    borderRadius: borderRadius.primary,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: ACTIONS.DISABLED,
    },
  },
  bodyContainer: {
    padding: '16px',
    height: 'calc(100% - 62px)',
  },
  footerContainer: {
    padding: '16px 20px',
    //   borderTop: `1px solid ${BORDER.DEFAULT}`,
  },
  rootDialog: {
    backgroundColor: 'rgba(0, 0, 0, 0.5) !important', // Set your desired background color here
  },
  // displayFlex: {
  //   display: 'flex',
  //   alignItems: 'center',
  //   gap: '4px',
  // },
  aicon: {
    width: '30px',
    height: '30px',
  },
  btnCredit: {
    border: 'none',
    backgroundColor: WARNING.W_400,
    color: BASE.BLACK,
    padding: '8px 14px 8px 14px',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '20px',
  },
  arlFont: {
    fontFamily: 'Arial',
    fontSize: '14px',
    lineHeight: '20px',
  },
  padSett: {
    paddingTop: '8px',
  },
  rightFoot: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    // padding: "16px",
    gap: '8px',
  },
  footerData: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
  },
})
